var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrows/Chevron_Up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M11.2947 9.70696C11.6853 9.31643 12.3184 9.31643 12.709 9.70696L16.2947 13.2927C16.9247 13.9227 16.4785 14.9998 15.5876 14.9998H8.41607C7.52516 14.9998 7.079 13.9227 7.70896 13.2927L11.2947 9.70696Z",
    fill: "#282A2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillArrowUp);
export default __webpack_public_path__ + "static/media/fill-arrow-up.bf438e4a5bade86732d24639649bd839.svg";
export { ForwardRef as ReactComponent };